import "./Contacto.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouchWithUs from "./sections/GetInTouchWithUs";
import ContactInformation from "./sections/ContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function ContactoPage() {
  return <div>
      <Header />
      <GetInTouchWithUs />
      <ContactInformation />
      <Footer />
    </div>;
}